import { config } from "./Conf";
/**
 * Class used to find shortest path to target
 */
var PathFind = /** @class */ (function () {
    function PathFind() {
        this.openList = [];
        this.closedList = [];
        this.targetFound = false;
    }
    /** @inheritdoc */
    PathFind.prototype.find = function (start, end, fieldsList) {
        var _this = this;
        var maxX = fieldsList.length;
        var maxY = fieldsList[0].length;
        this.openList = [start];
        this.closedList = [];
        this.targetFound = false;
        var pathFields = [];
        var pos = config.pos;
        var _loop_1 = function () {
            var list = this_1.openList.sort(function (a, b) { return a.cost - b.cost; }).filter(function (e, i, a) { if (e.cost === a[0].cost) {
                return e;
            } }).sort(function (a, b) { return a.costs.distanceCost - b.costs.distanceCost; });
            var curr = list[0];
            this_1.openList.splice(this_1.openList.indexOf(curr), 1);
            this_1.closedList.push(curr);
            if (curr == end) {
                this_1.targetFound = true;
                this_1.openList = [];
            }
            if (this_1.targetFound == false) {
                pos.forEach(function (e) {
                    if (curr.x + e.x >= 0 && curr.x + e.x < maxX && curr.y + e.y >= 0 && curr.y + e.y < maxY) {
                        var newX = curr.x + e.x;
                        var newY = curr.y + e.y;
                        if (fieldsList[newX][newY].free == true && _this.closedList.includes(fieldsList[newX][newY]) == false) {
                            var tempField = fieldsList[newX][newY];
                            // tempField.setCost(this.end, this.start, curr);
                            var costs = tempField.calculateCost(end, curr);
                            var sum = costs.roadCost + costs.distanceCost;
                            if (!tempField.parent || (tempField.parent && tempField.cost > sum)) {
                                tempField.setCost(costs);
                                tempField.parent = curr;
                            }
                            if (_this.openList.includes(tempField) == false) {
                                _this.openList.push(tempField);
                            }
                        }
                    }
                });
            }
        };
        var this_1 = this;
        do {
            _loop_1();
        } while (this.openList.length > 0);
        if (this.targetFound) {
            var field = end;
            while (field.parent) {
                pathFields.push(field);
                field = field.parent;
            }
            pathFields.push(start);
        }
        return pathFields;
    };
    return PathFind;
}());
export { PathFind };
